import { useEffect, useState } from 'react'
import {FaqBanner, FaqSearch, FaqTabSection, FaqText, FaqTitle, GettingStartedText, GettingStartedTitle, GettingStartedWrapper, GettingSubText, GettingText,  KnowledgeBase,MainTabSection, MostRecent, RelatedArticles, RelatedArticlesIcon, RelatedArticlesItem, RelatedArticlesList, RelatedArticlesTitle, SolutionTabSection } from './FaqStyle'
import { Breadcrumb, Container, Image, Tab, Tabs } from 'react-bootstrap'
import { MESSAGE } from '../../utils/message'
import CustomSearch from '../../components/common/customSearch'
import { useSelector,useDispatch } from 'react-redux'
import { faqArticlesHandler } from '../../redux/slices/faq/faqArticles-slice'
import DocumentIcon from '../../assests/images/document-text.svg';
import { faqDetailsHandler } from '../../redux/slices/faq/faqDetail-slice'
import { useLocation, useNavigate } from 'react-router-dom'
import Thumb from './thumb';
import DisLikeThumb from './disLikeThumb';

const FaqDetail = () => {
  const [searchValue, setSearchValue]= useState<string>('')
  const [isLike, setIsLike] = useState(false)
  const [isDisLike, setIsDisLike] = useState(false)
  
  const faqArticlesList = useSelector((state:any) => state?.faqArticles?.data)
  const faqDetails = useSelector((state:any) => state?.faqDetail?.data?.data)
  const dispatch: any = useDispatch();
  const {state} = useLocation();
  const navigate= useNavigate();
  useEffect(() =>{
    dispatch(faqArticlesHandler());
    dispatch(faqDetailsHandler())
  },[])

  const handleLike = () =>{
      setIsDisLike(false)
      setIsLike(true)
  }
  const handleDisLike = () =>{
      setIsDisLike(true)
      setIsLike(false)
  }
  return (
    <>
    <FaqBanner>
        <Container className="cont-w">
          <FaqTitle>{MESSAGE.faqHelp}</FaqTitle>
          <FaqText>{MESSAGE.helpTagline}</FaqText>
        </Container>
      </FaqBanner>
      <MainTabSection>
        <Container className="cont-w">
            <FaqTabSection>
            <Tabs defaultActiveKey="solution" fill activeKey={"solution"} onSelect={() => navigate(`/support/home`)}>
              <Tab eventKey="support_home" title="Support Home">
              </Tab>
              <Tab eventKey="solution" title="Solution">
                <FaqSearch>
                  <CustomSearch 
                    onSubmit={()=>{}}
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                    placeholder="Search GreatNonprofits Support Center..."
                  />
                </FaqSearch>
                <SolutionTabSection>
                  <KnowledgeBase>
                    <MostRecent>
                      <Breadcrumb>
                          <Breadcrumb.Item onClick={() => navigate('/support/home',{state:{activateTab:"solution"}})}> Solution</Breadcrumb.Item>
                          <Breadcrumb.Item onClick={() =>navigate('/faq-list',{state:{faqType:state.faqType,questionType:state?.questionType}}) }>{state?.faqType}</Breadcrumb.Item>
                          <Breadcrumb.Item active>{state?.questionType}</Breadcrumb.Item>
                         </Breadcrumb>
                         <GettingStartedWrapper>
                            <GettingStartedTitle>{faqDetails?.question}</GettingStartedTitle> 
                         <GettingStartedText>Modified on: {faqDetails?.date}</GettingStartedText>
                         <GettingText>
                         <GettingStartedText>
                           {faqDetails?.answer}
                            </GettingStartedText>
                         </GettingText>
                         <GettingSubText> 
                              {MESSAGE.helpful}
                              <Thumb isLike ={isLike} handleLike={handleLike} />
                              <DisLikeThumb isDisLike ={isDisLike} handleDisLike={handleDisLike}/>
                          </GettingSubText>
                        </GettingStartedWrapper>
                      </MostRecent>

                      <RelatedArticles>
                        <RelatedArticlesTitle> {MESSAGE.relatedArticles}</RelatedArticlesTitle>
                          <RelatedArticlesList>
                            {faqArticlesList?.data?.map((faq:any, index:number) =>(
                              <RelatedArticlesItem key={index+1}>
                                <RelatedArticlesIcon><Image src= {DocumentIcon} /> </RelatedArticlesIcon> 
                                {faq.question}
                            </RelatedArticlesItem>
                            ))}
                        </RelatedArticlesList>
                      </RelatedArticles>
                  </KnowledgeBase>
                </SolutionTabSection>
              </Tab>
            </Tabs>
            </FaqTabSection>
        </Container>
      </MainTabSection>
    </>
  )
}

export default FaqDetail
